export default "__VITE_ASSET__CNw7$oEs__"